<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © 2016 - {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://www.smartechc.com"
        target="_blank"
      >SmarTech Consulting LLC.</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <span class="float-md-right d-none d-md-block">
      Verison: 5.0.0
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
